export default __webpack_public_path__ + "static/media/details.25b13d6e.svg";